import { createGlobalStyle } from 'styled-components'

import { cssVariables } from './colors'

/**
 * Emits `--oh-*` CSS variables at :root from the canonical `colors` map.
 *
 * Mount once near the top of the React tree (inside ThemeProvider, before
 * any feature components). Plain .css files and styled-components written
 * as `var(--oh-orange)` now resolve through the same source as
 * `colors.ohOrange` — there's no second source of truth to drift from.
 */
const GlobalTokens = createGlobalStyle`
  :root {
${cssVariables}
  }
`

export default GlobalTokens
